<div class="chat-approver" [class.chat-approver--locked]="locked">
  @if (showLabel) {
    <div class="chat-approver__label">
      <span i18n="@@chatApproverLabel">Approver</span>
      <span class="chat-approver__required" aria-hidden="true">*</span>
    </div>
  }

  @if (locked && chosenSummary) {
    <div class="chat-approver__chosen">{{ chosenSummary }}</div>
  }

  <label class="chat-approver__field-wrap">
    <span class="chat-approver__field-label">{{ fieldLabel }}</span>
    <select [disabled]="locked" [(ngModel)]="selectedId">
      <option value="" i18n="@@chatApproverSelectPlaceholder">Select an approver…</option>
      @for (choice of choices; track choice.id) {
        <option [value]="choice.id">{{ approverName(choice) }}</option>
      }
    </select>
  </label>

  <div class="chat-approver__actions">
    <button
      type="button"
      class="chat-approver__continue"
      [disabled]="locked || !isValid"
      (click)="onContinue()"
      i18n="@@chatApproverConfirm"
    >
      Confirm
    </button>
  </div>
</div>
